import { render } from "./PopupInfoMuteChat.vue?vue&type=template&id=36a97fa5"
import script from "./PopupInfoMuteChat.vue?vue&type=script&lang=js"
export * from "./PopupInfoMuteChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__